import { Component } from '@angular/core';

@Component({
    selector   : 'glink-demo-content',
    templateUrl: './demo-content.component.html',
    styleUrls  : ['./demo-content.component.scss']
})
export class GLinkDemoContentComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
